import { ChantContext } from '../../gregorio-chant/ChantContext';
import { GlyphMeasurer } from '../GlyphMeasurer';
import { LyricsTextMeasurer } from '../LyricsTextMeasurer';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';

function romanize(num?: number): string {
  if (num === undefined || isNaN(num)) {
    return '';
  }
  const digits = String(+num).split(''),
    key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM',
      '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC',
      '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
  let roman = '', i = 3;
  while (i--) {
    roman = (key[+digits.pop()! + (i * 10)] || '') + roman;
  }
  return Array(+digits.join('') + 1).join('M') + roman;
}

export class Annotation extends ChantLayoutElement {
  // protected _dominantBaseline = 'hanging';
  // protected _classes = 'annotation';

  constructor(
    protected readonly context: ChantContext,
    private readonly mode: number,
    private readonly annotation: string[],
  ) {
    super(context);
  }

  public performLayout(staffLeft: number): void {
    this.bounds.setX(staffLeft / 2);
  }

  public createSvgFragments(): SVGElement[] {
    const elements: SVGElement[] = [];

    if (this.annotation.length === 0 && this.mode > 0) {
      this.annotation.push(romanize(this.mode));
    }

    if (this.annotation.length > 0) {
      let annotationArr = this.annotation;
      if (annotationArr.length > 2) {
        console.log('Annotation has more than 2 lines, which is not supported.');
        annotationArr = annotationArr.slice(0, 2);
      }

      const annotationraise = this._distanceConverter.lengthToPx(this._context.annotationraise);
      const annotationseparation = this._distanceConverter.lengthToPx(this._context.annotationseparation);

      const text1 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      text1.setAttribute('class', 'annotation');
      text1.setAttribute('x', String(this.bounds.x));
      text1.setAttribute('y', String(-annotationraise));
      text1.setAttribute('font-family', this._context.annotationTextFont);
      text1.setAttribute('font-size', this._context.annotationTextSize + 'px');
      text1.setAttribute('font-weight', String(this._context.annotationTextWeight));
      text1.setAttribute('fill', this._context.annotationTextColor);
      text1.setAttribute('text-anchor', 'middle');
      text1.setAttribute('dominant-baseline', 'hanging');
      text1.textContent = annotationArr[0];
      elements.push(text1);
      
      if (annotationArr.length > 1) {
        const bounds = LyricsTextMeasurer.instance.setElement(text1).getBBox();

        const text2 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        text2.setAttribute('class', 'annotation');
        text2.setAttribute('x', String(this.bounds.x));
        text2.setAttribute('y', String(bounds.height + annotationseparation - annotationraise));
        text2.setAttribute('font-family', this._context.annotationTextFont);
        text2.setAttribute('font-size', this._context.annotationTextSize + 'px');
        text2.setAttribute('font-weight', String(this._context.annotationTextWeight));
        text2.setAttribute('fill', this._context.annotationTextColor);
        text2.setAttribute('text-anchor', 'middle');
        text2.setAttribute('dominant-baseline', 'hanging');
        text2.textContent = annotationArr[1];
        elements.push(text2);
      }
    }

    return [
      ...elements,
      ...super.createSvgFragments(),
    ];
  }
}
